module.exports = __webpack_public_path__ + "static/mushroom-stew.f60c0ed5.jpg";